import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'mzic-box',
  imports: [CommonModule],
  templateUrl: './mzic-box.component.html',
  styleUrls: ['./mzic-box.component.scss'],
})
export class MzicBoxComponent {

  
  @Input() width!: string
  @Input() Height!: string
  
}
